import React from 'react'

import { SupportedCountry } from '~shared-components/utils/enums'

import NotFound from '../../pages/NotFound'
import { FROZEN_FLAG_VALUES } from './frozenFlags'
import { Flag } from './useFlags'

interface FlagRenderProps {
  extraCondition?: (
    flag?: boolean | Record<SupportedCountry, boolean>,
  ) => boolean
  // `enabledLanguages` holds per-language counts rather than an on/off gate, and
  // `maintenancePage` is not frozen, so neither can be rendered on.
  flag: Exclude<Flag, Flag.EnabledLanguages | Flag.MaintenancePage>
  ifFalse?: React.FC
}

/**
 * Renders `children` when a frozen flag is on, and `ifFalse` otherwise.
 *
 * The values are compile-time constants now, so there is nothing to wait for: the
 * loading spinner this used to show while LaunchDarkly had not yet answered is
 * gone, as is the warning for a flag missing from the payload — an unknown flag
 * is a type error instead. Call sites are unchanged; they still name the flag
 * through the `flag` prop.
 */
export const FlagRender: React.FC<FlagRenderProps> = ({
  flag,
  ifFalse = NotFound,
  children,
  extraCondition = () => true,
}) => {
  const Component = ifFalse
  const value = FROZEN_FLAG_VALUES[flag]

  if (value && extraCondition(value)) {
    return <>{children}</>
  }

  return <Component />
}
